import styled from 'styled-components';

export const ResponseContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const Avatar = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
  }
`;

export const AvatarBadge = styled.div`
  position: absolute;
  bottom: -2px;
  right: 0;
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  background: #f4f4f4;
  border-radius: 4px;
  padding: 16px;
  width: 420px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 420px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    gap: 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const Title = styled.h2`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #242424;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const MetadataRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const MetadataLabel = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #616161;
`;

export const MetadataValue = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #616161;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Paragraph = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #242424;
  margin: 0;
  width: 100%;
  white-space: pre-wrap;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const Strong = styled.strong`
  font-weight: 600;
`;

export const Regular = styled.span`
  font-weight: 400;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  background: transparent;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #242424;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  align-self: flex-start;

  &:hover {
    background: #e8e8e9;
    border-color: #babbbd;
  }
`;

